<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="stylesheet" href="home.component.scss" />
  </head>

  <body>
    <app-header></app-header>
    <div class="principal-container">
      <img
        src="../../../../assets/images/Render5_1.jpg"
        alt=""
        class="img header-img img-responsive"
      />
      <div class="text-and-button">
        <p class="title-img">
          Activa tu espacio en el mundo virtual
          <br />
          y ofrece a tu público una nueva experiencia.
        </p>
        <button class="btn btn-start-demo" (click)="openLoginModal('login')">
          <p class="start-demo1">Iniciar DEMO</p>
        </button>
      </div>
    </div>
    <a name="soluction"></a>
    <div class="solucion-container">
      <p class="title-solucion">
        INFOVERSE STUDIO
      </p>
      <div class="line-solucion"></div>
      <div class="descripcion-solucion">
        INFOVERSE STUDIO es una solución que activa y personaliza entornos de
        realidad virtual espectaculares en ambiente web, compatibles con todo
        tipo de dispositivos VR e integrados con sistemas transaccionales.
        <br />
        <br />
        Permite a tu público de interés visitar, reunirse o recorrer el entorno
        de realidad virtual, a través de avatares, generando una nueva
        experiencia de interacción con la marca, productos y canales de venta.
        <br />
        <br />
        INFOVERSE es una solución de computación en la nube, donde se activa la
        presencia en el metaverso de forma fácil y rápida. Selecciona el plan
        que más te convenga y listo. Tu entorno virtual queda disponible en
        minutos.
        <br />
        <br />
        La solución cuenta con una nutrida biblioteca de mundos virtuales
        existentes, pero también ofrecemos la capacidad de diseñar uno exclusivo
        a las necesidades.
        <br />
        <br />
      </div>
      <div class="text-align">
        Ofrece hoy los espacios inmersivos del mañana.
      </div>
    </div>
    <a name="worlds"></a>
    <div class="our-worlds">
      <p class="title-our-world">NUESTROS MUNDOS</p>
      <div class="line-our-world"></div>
      <div class="our-worlds-container">
        <div class="side-left">
          <p class="title-side-left">MARKETPLACE</p>
          <p class="description-side-left">
            En este Mundo puedes crear tu Shopping Centers Online y tener un
            amplio surtido de marcas o locales, los cuales pueden ser recorridos
            por los avatares de tus clientes. Cada local se puede personalizar
            con las marcas de tu preferencia, las góndolas y los productos a
            comercializar.
            <br />
            Después de comprar en las tiendas, se puede realizar un solo pago,
            sin tener que desplazarse.
            <br />
            Ahora ir de compras será toda una aventura.
          </p>
          <div class="probar-container">
            <!-- <button class="btn btn-probar" (click)="openLoginModal('login')"> -->
            <button class="btn btn-probar" (click)="openMarketplace()">
              <p>Leer más.</p>
            </button>
            <button
              class="btn btn-probar"
              (click)="goTo('https://metamall.com.co/personalizacion')"
            >
              <p>Caso de éxito</p>
            </button>
          </div>
        </div>
        <div class="side-right">
          <img
            src="https://d3iqhfs7sfm8r5.cloudfront.net/archivos/Gif+Marketplace.gif"
            alt=""
            class="img side-right-img img-responsive"
          />
        </div>
      </div>
      <div class="our-worlds-container">
        <div class="side-right-ferias">
          <p class="title-side-right-ferias">FERIAS DE NEGOCIOS</p>
          <p class="description-side-right-ferias">
            En este Mundo se puede crear tu propia sala de Exposición o Feria,
            disponer de stands para ofrecer productos y servicios para que sean
            recorridos por los visitantes de la feria.
            <br />
            Se puede personalizar la recepción, los pabellones y los stands.
            Cada stand permite agregar videos, fichas técnicas, brochures, sala
            de reuniones, catálogo de productos y muchas opciones más .
            <br />
            Los avatares de expositores y visitantes se encontraran en el
            metaverso.
          </p>
          <div class="probar-container">
            <button class="btn btn-probar" (click)="openFeriasNegocios()">
              <p>Leer más.</p>
            </button>
            <button
              class="btn btn-probar"
              (click)="
                goTo(
                  'https://showferreterovirtual.com/experiencia/personalization.html'
                )
              "
            >
              <p>Caso de éxito</p>
            </button>
          </div>
        </div>
        <div class="side-left-ferias">
          <div class="img-ferias">
            <img
              src="https://d3iqhfs7sfm8r5.cloudfront.net/archivos/Gif+feria.gif"
              alt=""
              class="img side-left-img-ferias img-responsive"
            />
          </div>
        </div>
      </div>
      <div class="our-worlds-container">
        <div class="side-left">
          <p class="title-side-left">CONFERENCIAS Y CEREMONIAS CORPORATIVAS</p>
          <p class="description-side-left">
            En este Mundo se crea un espacio para realizar todo tipo de eventos
            corporativos, seminarios o congresos. Permite personalizar el visual
            de las salas y a los avatares tener acceso en tiempo real a los
            conferencistas y contenido multimedia del evento. Las ceremonias y
            seminarios serán toda una aventura, que logrará impresionar a los
            participantes online y consigue un alto nivel de engagement con esta
            nueva experiencias.
          </p>
          <div class="probar-container">
            <button class="btn btn-probar" (click)="openConferenciaCeremonia()">
              <p>Leer más.</p>
            </button>
          </div>
        </div>
        <div class="side-right">
          <img
            src="https://d3iqhfs7sfm8r5.cloudfront.net/archivos/Gif+gala.gif"
            alt=""
            class="img side-right-img img-responsive"
          />
        </div>
      </div>
      <div class="our-worlds-container">
        <div class="side-right-ferias">
          <p class="title-side-right-ferias">FERIAS ESCOLARES</p>
          <p class="description-side-right-ferias">
            En este Mundo se pueden crear las ferias de la ciencia o de emprendimiento para que los estudiantes puedan compartir sus proyectos con diferentes cursos, con otras escuelas o colegios y con sus familias. Tendrás acceso a un mundo de realidad virtual con múltiples stands para presentar los proyectos y que sean recorridos por los visitantes de la feria.
            <br />
            Se puede personalizar la recepción, los pabellones y los stands. Cada stand permite agregar videos, fichas técnicas, brochures, sala de reuniones, catálogo de productos y muchas opciones más.
            <br />
            Los avatares de expositores y visitantes se encontraran en el mundo virtual.
          </p>
          <div class="probar-container">
            <button class="btn btn-probar" (click)="openFeriasEscolares()">
              <p>Leer más.</p>
            </button>
            <!-- <button
              class="btn btn-probar"
              (click)="
                goTo(
                  'https://showferreterovirtual.com/experiencia/personalization.html'
                )
              "
            >
              <p>Caso de éxito</p>
            </button> -->
          </div>
        </div>
        <div class="side-left-ferias">
          <div class="img-ferias">
            <img
              src="../../../../assets/images/Gif-escolar.gif"
              alt=""
              class="img side-left-img-ferias img-responsive"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="clients-reviews">
      <p class="title-clients-reviews">Reviews de clientes</p>
      <div class="line-clients-reviews"></div>
      <div class="carrusel" *ngFor="let r of reviews; let i = index">
        <div [ngClass]="{ 'ocultar-card': r.posicion != showPosicion }">
          <div class="card-clients-reviews">
            <div class="side-left-card">
              <div class="align-img">
                <img
                  [src]="r.logo_empresa"
                  alt=""
                  class="logo-empresa-review"
                />
              </div>
              <div class="logo-user-container">
                <div class="logo">
                  <img
                    src="../../../../assets/images/logo-user.png"
                    alt=""
                    class="logo-user"
                  />
                </div>
                <div class="textos">
                  <p class="nombre-user">{{ r.nombre_usuario }}</p>
                  <p class="cargo-user">{{ r.cargo_usuario }}</p>
                </div>
              </div>
            </div>
            <div class="side-right-card">
              <div class="comentario-container">
                <div class="logo-coma">
                  <img
                    src="../../../../assets/images/comas.png"
                    alt=""
                    class="img-coma"
                  />
                </div>
                <p class="description" [id]="r.id_elemento_html"></p>
              </div>
            </div>
          </div>
          <div class="flechas-container">
            <mat-icon
              [ngClass]="{
                'flecha-seleccionada': this.activeOption === 'arrow_back'
              }"
              (click)="getOptionSeleted(r.posicion, 'back')"
            >
              arrow_back
            </mat-icon>
            <mat-icon
              [ngClass]="{
                'flecha-seleccionada': this.activeOption === 'arrow_forward'
              }"
              (click)="getOptionSeleted(getOptionSeleted(r.posicion, 'next'))"
            >
              arrow_forward
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="confian-en-nosotros">
      <p class="title-confian-en-nosotros">Confían en nostros</p>
      <div class="line-confian-en-nosotros"></div>
      <div class="log-txt-container">
        <div class="logos">
          <img
            *ngFor="let r of reviews; let i = index"
            [src]="r.logo_empresa"
            alt=""
            class="img-empresa"
          />
          <img
            src="../../../../assets/images/dside.png"
            alt=""
            class="img-empresa"
          />
        </div>
        <div class="description-contacto">
          <div class="contacto">
            <button
              class="btn btn-start-demo"
              (click)="openLoginModal('login')"
            >
              <p>Iniciar DEMO</p>
            </button>
            <button class="btn btn-contact" (click)="goToContact()">
              <p>Contáctanos</p>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="noticias">
      <p class="title-noticias">Noticias</p>
      <div class="line-noticias"></div>
      <div class="cards-noticias">
        <div class="row">
          <div class="col" *ngFor="let n of news">
            <div class="container-principal">
              <div class="imagen-container">
                <img [src]="n.link_imagen_noticia" alt="" class="img-noticia" />
              </div>
              <div class="texto-boton">
                <p class="title-noticia">{{ n.titulo_noticia }}</p>
                <a [href]="n.link_noticia" target="_blank">
                  <button class="btn btn-leer-mas">
                    Leer más
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </body>
</html>
